<div class="flex flex-column flex-wrap">
  <p-card class="admin-group-card flex m-t-5 m-b-5 m-l-5 m-r-5" header="{{ title }}">
    <p class="m-b-0">{{ groupName?.name }} </p>
  </p-card>
</div>
